(ns frontend.ux-overhaul.listing.exit-opportunity.view
  (:require [frontend.state.current-session :as session]))

(def config
  {:listing-id               "exit-opportunity-listing"
   :entity-type              :entity.type/exit-opportunity
   :route-id                 :exit-opportunities-grid
   :create-action-id         :create-exit-opportunity
   :create-label             :exit-opportunity-add-button
   :pipeline-attribute       :exit-opportunity/pipeline
   :pipeline-key             :exit-opportunity-pipeline
   :module                   :module/exit-process-management
   :route-with-pipeline-id   :exit-opportunities-grid-with-pipeline
   :stage-entity-type        :entity.type/exit-opportunity-stage
   :stage-name-attribute     :exit-opportunity-stage/name
   :stage-pipeline-attribute :exit-opportunity-stage/pipeline
   :title                    :exit-opportunities
   :selected-pipeline        session/selected-exit-oppo-pipeline
   :all-pipelines            session/all-exit-oppo-pipelines
   :feature?                 session/exit-process-management?})
